import { Component, OnInit, Input, Output, EventEmitter, Renderer2, IterableDiffers, IterableDiffer, DoCheck, ElementRef } from '@angular/core';
import { appendExistStyleAttribute } from 'src/app/reports/helpers/element.helper';

@Component({
  selector: 'app-relation-zoom',
  templateUrl: './relation-zoom.component.html',
  styleUrls: ['./relation-zoom.component.scss']
})
export class RelationZoomComponent implements OnInit, DoCheck {

  //#region Inputs

  @Input() parent : Element;
  @Input() disabled : boolean;
  @Input() scale : number = 1;

  //#endregion

  //#region Outputs

  @Output() scaleChange = new EventEmitter<any>();

  //#endregion

  //#region Properties

  step: number = 0.05;
  max : number = 1.2;
  min : number = 0.7;

  elements = new Array<any>();
  differElements : IterableDiffer<any>;

  isScalingFinished : boolean = false;

  //#endregion

  //#region Ctor

  constructor(public elm : ElementRef,
              private renderer : Renderer2,
              private differs: IterableDiffers) { }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
    this.differElements = this.differs.find([]).create(null);

    setTimeout(() => {
      if (!this.scale) {
        this.scale = 1;
      }
      this.changeScale(this.scale);
    });
  }

  ngDoCheck(){
    this.findAvalablesElementsOnParent(this.parent);

    if(this.differElements.diff(this.elements) && this.isScalingFinished){
      this.changeScaleOfElements(this.scale);
    }
  }

  //#endregion

  //#region Scale Methods

  //#region Events

  changeScale(value){

    this.findAvalablesElementsOnParent(this.parent);

    this.changeScaleOfElements(value);

    this.scaleChange.emit(value);
  }

  increaseStep(event){
    if(!this.isScaleOnMaxValue()){
      this.scale += this.step;
      this.changeScale(this.scale);
    }
  }

  decreaseStep(event){
    if(!this.isScaleOnMinValue()){
      this.scale -= this.step;
      this.changeScale(this.scale);
    }
  }

  isScaleOnMaxValue() : boolean{
    return this.scale >= this.max;
  }

  isScaleOnMinValue() : boolean{
    return this.scale <= this.min;
  }

  //#endregion

  changeScaleOfElements(value : number){

    this.isScalingFinished = false;

    this.elements.forEach(element => {

      let transform = element.style['transform'],
          style = appendExistStyleAttribute(transform, 'scale', value.toString())

      this.renderer.setStyle(element, 'transform', style);
    });

    this.isScalingFinished = true;
  }

  findAvalablesElementsOnParent(parent : Element){
    for (let i = 0; i < parent.children.length; i++) {
      let element : any = parent.children[i];

      if(element && element !== this.elm.nativeElement){

        if(element.tagName == 'svg'){
            this.findAvalablesElementsOnParent(element);
        }
        else {
          this.appendToElements(element);
        }
      }
    }
  }

  appendToElements(element : any){
    if(this.elements.indexOf(element) === -1){
      this.elements.push(element);
    }
  }
  //#endregion

}
